export const BANK_APPROVED = '1';
export const BANK_PENDING = 0;
export const NEW_BANK_IS_APPROVED = BANK_PENDING;

const clean = (v) =>
  v === undefined || v === null ? '' : String(v).trim();

export function isBankApproved(bank) {
  if (!bank) return false;
  const raw = bank.HEB_IS_APPROVED !== undefined ? bank.HEB_IS_APPROVED : bank.IS_APPROVED;
  if (raw === true) return true;
  if (raw === false) return false;
  const s = clean(raw).toLowerCase();
  return s === 'true' || s === '1' || s === 'yes';
}

export const isBankPending = (bank) => !isBankApproved(bank);


export function toBankFlag(raw, fallback = false) {
  if (raw === undefined || raw === null || raw === '') return fallback;
  if (typeof raw === 'boolean') return raw;
  const t = String(raw).trim().toLowerCase();
  return t === 'true' || t === '1' || t === 'yes' || t === 'y';
}

export const isBankPrimary = (bank) => toBankFlag(bank?.HEB_IS_PRIMARY, false);

export function isBankActive(bank) {
  const raw = bank?.HEB_IS_ACTIVE !== undefined && bank?.HEB_IS_ACTIVE !== null
    ? bank.HEB_IS_ACTIVE
    : bank?.HBD_IS_ACTIVE;
  if (raw === undefined || raw === null || raw === '') return true;
  if (typeof raw === 'boolean') return raw;
  const t = String(raw).trim().toLowerCase();
  return !(t === 'false' || t === '0' || t === 'no' || t === 'n');
}


export const pendingBanks = (employee) =>
  (employee?.Banks || []).filter(isBankPending);

export const bankKey = (bank) =>
  clean(bank?.HEB_EMPLOYEE_BANK_ID) || clean(bank?.HEB_ACCOUNT_NUMBER);

export function buildBankApprovalPayload(bank, approvedBy) {
  return {
    p_isApproved: BANK_APPROVED,
    p_hedApprovedBy: approvedBy,
    p_hedEmployeeId: bank.HEB_EMPLOYEE_ID,
    p_hebEmployeeBankId: bank.HEB_EMPLOYEE_BANK_ID,
  };
}